import { gql } from '@apollo/client'

export const GET_TOPICS_FILTER = gql`
  query getTopicsFilter(
    $pagination: TerritoryPaginationInput!
    $filters: ListTerritoryFilters!
    $sort: ListTerritoriesSort!
  ) {
    listTerritoriesPaginated(pagination: $pagination, filters: $filters, sort: $sort) {
      cursor
      totalCount
      data {
        territoryId
        name

        ... on Topic {
          language
        }
      }
    }
  }
`

export const GET_TOPIC_BY_ID = gql`
  query getTopicById($territoryId: ID!) {
    getTerritory(territoryId: $territoryId) {
      name
      territoryId
    }
  }
`
